import React, { Dispatch, FC, SetStateAction, useEffect, useRef } from "react";
import { ButtonBox, GridTable } from "..";
import {
  LookupItemModel,
  RequestActionModel,
  RowStateEnum,
  ItemModel,
  UserConfigurationModel,
} from "../../models";
import { generateGuid, getLabelName } from "../../utils";
import { handleGenerateItemUnitColumns } from "./uiHelper/itemUnitDataTableColumns";
import {
  getItemUnits,
  handleAddItemUnitRow,
} from "./businessLogic/itemStoresBl";

export const ItemUnitManager: FC<{
  setState: Dispatch<SetStateAction<ItemModel>>;
  state: ItemModel;
  setIsRefresh: Dispatch<SetStateAction<boolean>>;
  isRefresh: boolean;
  taxValue: number;
  unitList: LookupItemModel[];
  userConfiguration: UserConfigurationModel;
  onActionEvent: (o: RequestActionModel) => void;
}> =  ({
  setState,
  state,
  setIsRefresh,
  isRefresh,
  taxValue,
  unitList,
  userConfiguration,
  onActionEvent = () => {},
}) => {
  //#region state
  const prevStateRef = useRef<ItemModel>();
  //#endregion
  //#region variables
  const currentItemUnits = state?.ItemsInstores?.[0]?.Item_unit || [];
  //#endregion
  //#region useEffect\
  useEffect(() => {
    if (isRefresh) {
      const updatedItemUnits = currentItemUnits.map((unit) => ({
        ...unit,
        Unit_ID: Number(unitList[0].value),
        factor: 1,
        rowKey: generateGuid(),
      }));
      setState((prev) => ({
        ...prev,
        ItemsInstores: [
          {
            ...prev?.ItemsInstores?.[0],
            Item_unit: updatedItemUnits,
          },
        ],
      }));
    }
    prevStateRef.current = state;
    setIsRefresh(false);
  }, [isRefresh]);
  //#endregion
  //#region variables
  //const generateItemUnitsAntdColumns = [...handleGenerateAntdItemUnitColumns(taxValue, unitList, setState, isRefresh)];
  const generateItemUnitsColumns = [
    ...handleGenerateItemUnitColumns(
        //taxValue,
        unitList,
        setState,
        userConfiguration,
        isRefresh
    ),
  ];
  //#endregion
  //#region html
  return (
    <>
      <div className="item-unit-list mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
          <ButtonBox
            iconType="plus"
            id="addItemBtn"
            variant=""
            className="btn-gradient-info mb-3"
            size="sm"
            onClick={() => {
              handleAddItemUnitRow(
                setState,
                unitList[0].value === null ? 0 : +unitList[0].value
              );
            }}
          >
            {getLabelName("Add")}
          </ButtonBox>
        </div>
        <GridTable
          columns={generateItemUnitsColumns}
          customStyles={{
            cells: {
              style: {
                paddingLeft: "8px",
                paddingRight: "8px",
              },
            },
          }}
          data={getItemUnits(state).filter(
            (row) => row.rowState !== RowStateEnum.Delete
          )}
          totalRows={1000}
          currentPage={1}
          pageSize={10000}
          paginationType="none"
        />

        {/*<AntdTableComponent*/}
        {/*    data={getItemUnits(state).filter(*/}
        {/*        (row) => row.rowState !== RowStateEnum.Delete*/}
        {/*    )}*/}
        {/*    columns={generateItemUnitsAntdColumns}*/}
        {/*    rowKey="rowKey"*/}
        {/*/>*/}
      </div>
    </>
  );
  //#endregion
};
